
























import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import MarkdownReader from "@/components/markdown-editor/MarkdownReader.vue";
@Component({
  components: { MarkdownReader }
})
export default class DemoComponent extends Vue {
  private info = {
    title: "",
    desc: "",
    source: "",
    createdAt: "",
    scanTotal: 0
  };
  private loading = true;
  async created() {
    this.loading = true;
    await this.getNewsDetail();
    await this.addCount();
    this.loading = false;
  }
  // 新详详情
  private async getNewsDetail() {
    const res = await this.$axios("getNewsDetail", {
      id: this.$route.params.id
    });
    this.info = res.data.data;
    this.info.createdAt = moment(this.info.createdAt).format(
      "YYYY-MM-DD HH:mm:SS"
    );
  }
  private async addCount() {
    await this.$axios("addCount", { id: this.$route.params.id });
  }
}
